import React from 'react';

const VARIANT_CLASS = {
    standard: 'dashboard-page',
    singleTable: 'dashboard-page single-table-page',
    workflow: '',
    minimal: 'page-minimal',
};

export default function PageRoot({ variant = 'standard', className = '', children }) {
    const variantClass = VARIANT_CLASS[variant] || '';
    const classes = ['customDiv', variantClass, className].filter(Boolean).join(' ');
    return <div className={classes}>{children}</div>;
}
